import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class MobileAgentServiceService {
  constructor(private readonly deviceService: DeviceDetectorService) {}

  public isMobileDevice(): boolean {
    return this.deviceService.isMobile();
  }
}
